<template lang='pug'>
  include /mixins
  +b.i-filter(:class="{'is-active': filterIsActive}")
    transition(
      name='fade'
    )
      +b.button-show-filter(
        @click.prevent='togglerMenu = true'
      ) {{ _('Показать фильтры')}}
    transition(
      name='fade'
    )
      +b.place-filter.--adaptive(
        v-show='togglerMenu'
      )
        +b.close-filter(@click='togglerMenu = false') {{ _('Закрыть фильтр')}} &#10005;
        filter-ui(
          ref="filterUi"
          :value="prepared"
          :filters="filters"
          :additional-resource="additionalResource"
          @input="handleInputFilter"
          :range='gaveData'
        )
        //- row(:justify="['center', 'end-xl']")
        //-   cell(cols='12 6-md 3-lg')
        portal(to='clear-filter')
          +b.BUTTON.btn-reset(@click.prevent='handleInputFilter({}, "clear"), gaveData = !gaveData')
            +e.SPAN.text {{ _("Скинути") }}
    +b.place-filter.--main
      filter-ui(
        ref="filterUi"
        :value="prepared"
        :filters="filters"
        :additional-resource="additionalResource"
        @input="handleInputFilter"
        :range='gaveData'
      )
      //- row(:justify="['center', 'end-xl']")
      //-   cell(cols='12 6-md 3-lg')
      portal(to='clear-filter')
        +b.BUTTON.btn-reset(@click.prevent='handleInputFilter({}, "clear"), gaveData = !gaveData')
          +e.SPAN.text {{ _("Скинути") }}
</template>

<script>

import ControllerMixin from './mixins/ControllerMixin'

export default {
  mixins: [ControllerMixin],
  data() {
    return {
      togglerMenu: false,
      gaveData: false,
    }
  },
}

</script>
